import {
  Hammer,
  Trees,
  Wrench,
  ShieldCheck,
  Paintbrush,
  Building2,
  type LucideIcon,
} from "lucide-react";

export interface ServiceItem {
  slug: string;
  icon: LucideIcon;
  title: string;
  desc: string;
  items: string[];
}

export const services: ServiceItem[] = [
  {
    slug: "interior-upgrades",
    icon: Hammer,
    title: "Interior Upgrades",
    desc: "Feature walls, media walls, electric fireplace builds, wall panelling, TV mounting, shelving and flat-pack installation.",
    items: [
      "Feature Walls, Media Walls & Fireplaces",
      "Wall Panelling & Cladding",
      "TV Mounting & Shelving",
      "Flat Pack & Small Fit-Out Works",
    ],
  },
  {
    slug: "outdoor-improvements",
    icon: Trees,
    title: "Outdoor Improvements",
    desc: "Fencing, gates, synthetic grass, landscaping, garden clean-ups, pressure washing and yard makeovers.",
    items: [
      "Fencing & Gates",
      "Synthetic Grass",
      "Landscaping & Garden Clean-Ups",
      "Pressure Washing",
    ],
  },
  {
    slug: "property-maintenance",
    icon: Wrench,
    title: "Property Maintenance",
    desc: "General repairs, rental property maintenance, end-of-lease repairs, patching, painting touch-ups and small handyman jobs.",
    items: [
      "General Repairs",
      "Rental Property Maintenance",
      "End-of-Lease Repairs",
      "Patch, Paint & Touch-Ups",
    ],
  },
  {
    slug: "security-access",
    icon: ShieldCheck,
    title: "Security & Access",
    desc: "Security camera installation, sensor lights, smart doorbells, locks, gate hardware and property security upgrades.",
    items: [
      "Security Camera Installation",
      "Sensor Lights & Smart Doorbells",
      "Locks, Gates & Door Hardware",
      "Property Security Upgrades",
    ],
  },
  {
    slug: "renovation-support",
    icon: Paintbrush,
    title: "Renovation Support",
    desc: "Cosmetic renovations, garage and studio fit-out support, granny flat fit-out support and pre-sale property improvements.",
    items: [
      "Cosmetic Renovations",
      "Garage & Studio Fit-Out Support",
      "Granny Flat Fit-Out Support",
      "Pre-Sale Property Improvements",
    ],
  },
  {
    slug: "commercial-services",
    icon: Building2,
    title: "Commercial Services",
    desc: "Shop, office and warehouse maintenance, small fit-out works, signage installation support and end-of-lease make-good works.",
    items: [
      "Shop & Office Maintenance",
      "Small Fit-Out Works",
      "Signage Installation Support",
      "End-of-Lease Make-Good",
    ],
  },
];

export interface PackageItem {
  icon: LucideIcon;
  title: string;
  desc: string;
  includes: string[];
  addons: string[];
}

export const packages: PackageItem[] = [
  {
    icon: Hammer,
    title: "Media Wall Package",
    desc: "A complete media wall transformation for a clean, modern living space.",
    includes: ["Feature wall", "TV mounting", "Fireplace build", "Acoustic panels", "Cladding", "Floating shelves"],
    addons: ["LED lighting", "Cable concealment", "Sound bar mounting"],
  },
  {
    icon: Trees,
    title: "Backyard Makeover Package",
    desc: "Refresh your outdoor space with a tidy, low-maintenance makeover.",
    includes: ["Synthetic grass", "Edging", "Mulch", "Garden clean-up", "Fencing touch-ups", "Pressure washing"],
    addons: ["Privacy screens", "Garden lighting", "Planter boxes"],
  },
  {
    icon: Wrench,
    title: "Rental Refresh Package",
    desc: "Get rentals tenant-ready with a practical maintenance refresh.",
    includes: ["Patch and paint", "Door and handle repairs", "Silicone replacement", "Small maintenance jobs", "Pressure washing", "Rubbish removal"],
    addons: ["Blind replacement", "Smoke alarm checks", "Deep clean coordination"],
  },
  {
    icon: Paintbrush,
    title: "Pre-Sale Upgrade Package",
    desc: "Boost curb appeal and presentation before listing your property.",
    includes: ["Minor repairs", "Curb appeal improvements", "Feature walls", "Garden clean-up", "Fencing repairs", "Painting touch-ups"],
    addons: ["Styling coordination", "Letterbox upgrade", "Front door refresh"],
  },
  {
    icon: ShieldCheck,
    title: "Home Security Package",
    desc: "Upgrade home security and access with modern, app-connected hardware.",
    includes: ["Security cameras", "Sensor lights", "Smart doorbell", "Lock upgrades", "Side gate security", "App setup"],
    addons: ["Additional cameras", "Keypad entry", "Network setup"],
  },
  {
    icon: Building2,
    title: "Commercial Maintenance Package",
    desc: "Keep your shop or office maintained and lease-compliant.",
    includes: ["Shop repairs", "Office maintenance", "Fit-out touch-ups", "Signage support", "Security upgrades", "End-of-lease make-good"],
    addons: ["After-hours scheduling", "Recurring maintenance plan", "Branding install support"],
  },
];

export const serviceAreas = [
  "Broadmeadows",
  "Craigieburn",
  "Glenroy",
  "Fawkner",
  "Coburg",
  "Pascoe Vale",
  "Tullamarine",
  "Mickleham",
  "Epping",
  "Melbourne",
];
